export const NEWS = 1
export const TRAINING = 2
